<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='dialog')
        v-card()
          v-card-title(class="grey lighten-2")
            v-row
              v-col(sm="11" md="11") 
                span(style="margin-left:-10px;margin-bottom:10px") List Notification Logs 
              v-col(sm="1" md="1" )   
                v-icon.mr-2(
                  color="black",
                  dark,
                  style="float:right"
                  @click="dialog = false"
                ) mdi-close
          v-card-text(style="padding:10px")
              v-row
                v-col(sm="4") 
                  v-select(:items='["all", "email", "whatsapp"]' v-model="filterTipe" label="Tipe" clearable @change="handleChangeFilter()") 
                v-col(sm="4") 
                  v-select(:items='["success", "failed"]' v-model="filterStatus" label="Status" clearable @change="handleChangeFilter()") 
                v-col(sm="4") 
                  v-text-field(v-model="filterPenerima" label="Penerima" clearable @keyup.enter="handleChangeFilter()")
              v-data-table.elevation-1(
                :headers="ip.headers",
                :must-sort="true",
                :sort-by="pagination.sortBy",
                :sort-desc="pagination.descending",
                :items="ip.items",
              )
                template(v-slot:item.createdAt="{ item }")
                  label {{ formatDate(item.createdAt )}} 
                template(v-slot:item.status="{ item }")
                  v-chip(
                    label,
                    small,
                    :color="item.status == 'failed' ? 'red' : 'green'",
                    text-color="white"
                  ) {{ item.status }}
                  
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import helper from "../helper/index.js";

export default {

name:"ModalNotificationLogs",
props:{
  'onClose': Boolean,
  'dataIpNo': String,
  "actionFor": {default: null, type: String}
},
data () {
      return {
        phoneNumLength: 15,
        dialog: false,
        valid: true,
        name :"",
        nohp:"",
        email:"",
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        ip: {
          headers: [
            {
              text: 'Nomor IP',
              align: 'start',
              sortable: false,
              value: 'ipNo',
            },
            { text: 'Tanggal', value: 'createdAt' },
            { text: 'Tipe', value: 'service' },
            { text: 'Status', value: 'status' },
            { text: 'Penerima', value: 'receiver' },
            { text: 'Error', value: 'error' },
            { text: 'Trigger', value: 'actionFrom' },
          ],
          items: []
        }, 
        pagination: {
          sortBy: ["ipNo"],
          descending: [true],
        },
        filterTipe: "",
        filterStatus: "",
        filterPenerima: ""
      }
    },
  computed: {
    ...mapState(["API_URL",'visitorRules'])
  },
  mounted() {

  },
  methods: {
    formatDate:helper.formatDate,
    handleChangeFilter() {
      let tipe = this.filterTipe ?? ""
      if (tipe == "all") tipe = ""
      const config = {
        method: "post",
        url: `${this.API_URL}/v1/requests/admin/notification-logs`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: {
          ipNo : this.dataIpNo, 
          service : tipe, 
          status : this.filterStatus ?? "", 
          receiver : this.filterPenerima ?? ""
        },
      };
      axios(config).then((res) => {
        this.ip.items = res.data.data
      }).catch((err) => {
        console.log(err.response)
      })
    }
  },
  watch : {
    dialog(param){
      if (!param) return;
      this.handleChangeFilter();
    }
  }
}
</script>

<style>

</style>